$("#BrightCoveAccessKeyForm button").click(function () {
    event.preventDefault();
    // Remove all potential content before gathering new
    $("#BrightCoveAccessKeyArea .content").empty();
    $("#BrightCoveAccessKeyArea .error").hide();
    $("#BrightCoveAccessKeyArea .loading").show();
    $("#BrightCoveAccessKeyArea #BrightCoveAccessKeyForm").hide();

    var form = $("#BrightCoveAccessKeyForm").serializeArray();
    $.get("/api/accessKey/" + form[0].value + "/" + form[1].value,
        function(data) {
            $("#BrightCoveAccessKeyArea .loading").hide();
            $("#BrightCoveAccessKeyArea .embedArea").show();
            $("#BrightCoveAccessKeyArea .content").append(data);
        })
        .fail(function () {
            $("#BrightCoveAccessKeyArea .loading").hide();
            $("#BrightCoveAccessKeyArea #BrightCoveAccessKeyForm").show();
            $("#BrightCoveAccessKeyArea .error").show();
        });
});

$("#BrightCoveEmailForm button").click(function () {
    var $subscribeForm = $("#BrightCoveAccessKeyArea #BrightCoveEmailForm");
    // Remove all potential content before gathering new
    $("#BrightCoveAccessKeyArea .content").empty();
    $("#BrightCoveAccessKeyArea .error").hide();
    $("#BrightCoveAccessKeyArea .loading").show();
    $("#BrightCoveAccessKeyArea #BrightCoveEmailForm").hide();

    var isvalidform = $subscribeForm.valid();
    if (isvalidform) {
        var email = $("#email").val();
        var blockId = $("#blockId").val();

        var postData = { email: email, Id: blockId };

        $.ajax({
            url: '/api/Apsis/Subscribe/',
            data: postData,
            dataType: "json",
            traditional: true,
            success: function (data) {
                $("#BrightCoveAccessKeyArea .loading").hide();
                $("#BrightCoveAccessKeyArea .embedArea").show();
                $("#BrightCoveAccessKeyArea .content").append(data);
            },
            error: function (data) {
                $("#BrightCoveAccessKeyArea .loading").hide();
                $("#BrightCoveAccessKeyArea #BrightCoveEmailForm").show();
                $("#BrightCoveAccessKeyArea .error").show();
            }
        });
    }
    event.preventDefault();
});